export const specialChars = "!@#$%^&*()_+-=[]{}|<>?,./;:~`'\"\\";
export const cannotBeInName = '()[]":;<>,\\';
